import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Eix from '../Eix/Eix'

import Eixos1 from '../../assets/img/Eix1.png'
import Eixos2 from '../../assets/img/Eix2.png'
import Eixos3 from '../../assets/img/Eix3.png'
import Eixos4 from '../../assets/img/Eix4.png'

import styles from './Responsable.module.css'

const Responsable = ( props ) => {

    const [ data, setData ] = useState(null)
    const [ numberEix, setNumberEix ] = useState(null)
    const [ visible, setVisible ] = useState(false)

    useEffect(() => {
        setData(props.data)
        setNumberEix(props.number)
        setVisible(false)
    },[props.data, props.number])

    const handleOnChange = () => {
        setVisible(!visible)
    }
    
    const dataTitles = data && Object.keys(data)
    const dataTitlesValues = data && Object.values(data)

    const dataEixos = dataTitles && Object.values(dataTitlesValues[2])
    const nameEixos = dataEixos && dataEixos.map(element => element.titol)
    
    const objectiusEixos = dataEixos && dataEixos.map(element => element.elements)
    const objectiusEix1 = objectiusEixos && objectiusEixos[0]
    const objectiusEix2 = objectiusEixos && objectiusEixos[1]
    const objectiusEix3 = objectiusEixos && objectiusEixos[2]
    const objectiusEix4 = objectiusEixos && objectiusEixos[3]

    const titolsEix1 = objectiusEix1 && [objectiusEix1["504"].titol,objectiusEix1["505"].titol,objectiusEix1["506"].titol,objectiusEix1["507"].titol]
    const titolsEix2 = objectiusEix2 && [objectiusEix2["508"].titol,objectiusEix2["509"].titol,objectiusEix2["510"].titol,objectiusEix2["511"].titol]
    const titolsEix3 = objectiusEix3 && [objectiusEix3["512"].titol,objectiusEix3["513"].titol,objectiusEix3["514"].titol]
    const titolsEix4 = objectiusEix4 && [objectiusEix4["515"].titol,objectiusEix4["516"].titol,objectiusEix4["517"].titol]
    
    // Array de titols
    const titolsArray = [ titolsEix1, titolsEix2, titolsEix3, titolsEix4 ]

    const accionsEix1objetiu1 = objectiusEix1 && objectiusEix1["504"].accions
    const accionsEix1objetiu2 = objectiusEix1 && objectiusEix1["505"].accions
    const accionsEix1objetiu3 = objectiusEix1 && objectiusEix1["506"].accions
    const accionsEix1objetiu4 = objectiusEix1 && objectiusEix1["507"].accions
    const accionsEix2objetiu1 = objectiusEix2 && objectiusEix2["508"].accions
    const accionsEix2objetiu2 = objectiusEix2 && objectiusEix2["509"].accions
    const accionsEix2objetiu3 = objectiusEix2 && objectiusEix2["510"].accions
    const accionsEix2objetiu4 = objectiusEix2 && objectiusEix2["511"].accions
    const accionsEix3objetiu1 = objectiusEix3 && objectiusEix3["512"].accions
    const accionsEix3objetiu2 = objectiusEix3 && objectiusEix3["513"].accions
    const accionsEix3objetiu3 = objectiusEix3 && objectiusEix3["514"].accions
    const accionsEix4objetiu1 = objectiusEix4 && objectiusEix4["515"].accions
    const accionsEix4objetiu2 = objectiusEix4 && objectiusEix4["516"].accions
    const accionsEix4objetiu3 = objectiusEix4 && objectiusEix4["517"].accions

    // Array d'accions
    const accionsArrayEix1 = [accionsEix1objetiu1, accionsEix1objetiu2, accionsEix1objetiu3, accionsEix1objetiu4]
    const accionsArrayEix2 = [accionsEix2objetiu1, accionsEix2objetiu2, accionsEix2objetiu3, accionsEix2objetiu4]
    const accionsArrayEix3 = [accionsEix3objetiu1, accionsEix3objetiu2, accionsEix3objetiu3]
    const accionsArrayEix4 = [accionsEix4objetiu1, accionsEix4objetiu2, accionsEix4objetiu3]

    const accionsArray = [ accionsArrayEix1, accionsArrayEix2, accionsArrayEix3, accionsArrayEix4 ]

    // Array responsables
    const responsablesEix1objetiu1 = accionsEix1objetiu1 && accionsEix1objetiu1.map(element => element.responsable)
    const responsablesEix1objetiu2 = accionsEix1objetiu2 && accionsEix1objetiu2.map(element => element.responsable)
    const responsablesEix1objetiu3 = accionsEix1objetiu3 && accionsEix1objetiu3.map(element => element.responsable)
    const responsablesEix1objetiu4 = accionsEix1objetiu4 && accionsEix1objetiu4.map(element => element.responsable)
    const responsablesEix2objetiu1 = accionsEix2objetiu1 && accionsEix2objetiu1.map(element => element.responsable)
    const responsablesEix2objetiu2 = accionsEix2objetiu2 && accionsEix2objetiu2.map(element => element.responsable)
    const responsablesEix2objetiu3 = accionsEix2objetiu3 && accionsEix2objetiu3.map(element => element.responsable)
    const responsablesEix2objetiu4 = accionsEix2objetiu4 && accionsEix2objetiu4.map(element => element.responsable)
    const responsablesEix3objetiu1 = accionsEix3objetiu1 && accionsEix3objetiu1.map(element => element.responsable)
    const responsablesEix3objetiu2 = accionsEix3objetiu2 && accionsEix3objetiu2.map(element => element.responsable)
    const responsablesEix3objetiu3 = accionsEix3objetiu3 && accionsEix3objetiu3.map(element => element.responsable)
    const responsablesEix4objetiu1 = accionsEix4objetiu1 && accionsEix4objetiu1.map(element => element.responsable)
    const responsablesEix4objetiu2 = accionsEix4objetiu2 && accionsEix4objetiu2.map(element => element.responsable)
    const responsablesEix4objetiu3 = accionsEix4objetiu3 && accionsEix4objetiu3.map(element => element.responsable)

    let arrayReponsables = responsablesEix1objetiu1 && responsablesEix1objetiu1.concat(responsablesEix1objetiu2)
    arrayReponsables =  arrayReponsables && arrayReponsables.concat(responsablesEix1objetiu3)
    arrayReponsables =  arrayReponsables && arrayReponsables.concat(responsablesEix1objetiu4)
    arrayReponsables =  arrayReponsables && arrayReponsables.concat(responsablesEix2objetiu1)
    arrayReponsables =  arrayReponsables && arrayReponsables.concat(responsablesEix2objetiu2)
    arrayReponsables =  arrayReponsables && arrayReponsables.concat(responsablesEix2objetiu3)
    arrayReponsables =  arrayReponsables && arrayReponsables.concat(responsablesEix2objetiu4)
    arrayReponsables =  arrayReponsables && arrayReponsables.concat(responsablesEix3objetiu1)
    arrayReponsables =  arrayReponsables && arrayReponsables.concat(responsablesEix3objetiu2)
    arrayReponsables =  arrayReponsables && arrayReponsables.concat(responsablesEix3objetiu3)
    arrayReponsables =  arrayReponsables && arrayReponsables.concat(responsablesEix4objetiu1)
    arrayReponsables =  arrayReponsables && arrayReponsables.concat(responsablesEix4objetiu2)
    arrayReponsables =  arrayReponsables && arrayReponsables.concat(responsablesEix4objetiu3)

    const resultArrayResponsables = arrayReponsables && arrayReponsables.filter((item,index)=>{
        return arrayReponsables.indexOf(item) === index
    })

    // Mitjana de compliment accions Eix 1 - Objectiu 1
    const accionsEix11Compliment = accionsEix1objetiu1 && accionsEix1objetiu1.map(element => {
        // return element && parseInt(element.valoracions[0].compliment)
        return element && parseInt(element.valoracions[(element.valoracions).length-1].compliment)
    })
    let number11 = accionsEix11Compliment && accionsEix11Compliment.length
    let total11 = accionsEix11Compliment && accionsEix11Compliment.reduce((a, b) => a + b, 0)
    let average11 = number11 && total11 && (total11/number11).toFixed(2)

    // Mitjana de compliment accions Eix 1 - Objectiu 2
    const accionsEix12Compliment = accionsEix1objetiu2 && accionsEix1objetiu2.map(element => {
        // return element && parseInt(element.valoracions[0].compliment)
        return element && parseInt(element.valoracions[(element.valoracions).length-1].compliment)
    })
    let number12 = accionsEix12Compliment && accionsEix12Compliment.length
    let total12 = accionsEix12Compliment && accionsEix12Compliment.reduce((a, b) => a + b, 0)
    let average12 = number12 && total12 && (total12/number12).toFixed(2)

    // Mitjana de compliment accions Eix 1 - Objectiu 3
    const accionsEix13Compliment = accionsEix1objetiu3 && accionsEix1objetiu3.map(element => {
        // return element && parseInt(element.valoracions[0].compliment)
        return element && parseInt(element.valoracions[(element.valoracions).length-1].compliment)
    })
    let number13 = accionsEix13Compliment && accionsEix13Compliment.length
    let total13 = accionsEix13Compliment && accionsEix13Compliment.reduce((a, b) => a + b, 0)
    let average13 = number13 && total13 && (total13/number13).toFixed(2)

    // Mitjana de compliment accions Eix 1 - Objectiu 4
    const accionsEix14Compliment = accionsEix1objetiu4 && accionsEix1objetiu4.map(element => {
        // return element && parseInt(element.valoracions[0].compliment)
        return element && parseInt(element.valoracions[(element.valoracions).length-1].compliment)
    })
    let number14 = accionsEix14Compliment && accionsEix14Compliment.length
    let total14 = accionsEix14Compliment && accionsEix14Compliment.reduce((a, b) => a + b, 0)
    let average14 = number14 && total14 && (total14/number14).toFixed(2)

    // Array mitjanes
    let averageArray1 = [average11, average12, average13, average14]

    // Mitjana de compliment accions Eix 2 - Objectiu 1
    const accionsEix21Compliment = accionsEix2objetiu1 && accionsEix2objetiu1.map(element => {
        // return element && parseInt(element.valoracions[0].compliment)
        return element && parseInt(element.valoracions[(element.valoracions).length-1].compliment)
    })
    let number21 = accionsEix21Compliment && accionsEix21Compliment.length
    let total21 = accionsEix21Compliment && accionsEix21Compliment.reduce((a, b) => a + b, 0)
    let average21 = number21 && total21 && (total21/number21).toFixed(2)

    // Mitjana de compliment accions Eix 2 - Objectiu 2
    const accionsEix22Compliment = accionsEix2objetiu2 && accionsEix2objetiu2.map(element => {
        // return element && parseInt(element.valoracions[0].compliment)
        return element && parseInt(element.valoracions[(element.valoracions).length-1].compliment)
    })
    let number22 = accionsEix22Compliment && accionsEix22Compliment.length
    let total22 = accionsEix22Compliment && accionsEix22Compliment.reduce((a, b) => a + b, 0)
    let average22 = number22 && total22 && (total22/number22).toFixed(2)

    // Mitjana de compliment accions Eix 2 - Objectiu 3
    const accionsEix23Compliment = accionsEix2objetiu3 && accionsEix2objetiu3.map(element => {
        // return element && parseInt(element.valoracions[0].compliment)
        return element && parseInt(element.valoracions[(element.valoracions).length-1].compliment)
    })
    let number23 = accionsEix23Compliment && accionsEix23Compliment.length
    let total23 = accionsEix23Compliment && accionsEix23Compliment.reduce((a, b) => a + b, 0)
    let average23 = number23 && total23 && (total23/number23).toFixed(2)

    // Mitjana de compliment accions Eix 2 - Objectiu 4
    const accionsEix24Compliment = accionsEix2objetiu4 && accionsEix2objetiu4.map(element => {
        // return element && parseInt(element.valoracions[0].compliment)
        return element && parseInt(element.valoracions[(element.valoracions).length-1].compliment)
    })
    let number24 = accionsEix24Compliment && accionsEix24Compliment.length
    let total24 = accionsEix24Compliment && accionsEix24Compliment.reduce((a, b) => a + b, 0)
    let average24 = number24 && total24 && (total24/number24).toFixed(2)
    
    // Array mitjanes
    let averageArray2 = [average21, average22, average23, average24]

    // Mitjana de compliment accions Eix 3 - Objectiu 1
    const accionsEix31Compliment = accionsEix3objetiu1 && accionsEix3objetiu1.map(element => {
        // return element && parseInt(element.valoracions[0].compliment)
        return element && parseInt(element.valoracions[(element.valoracions).length-1].compliment)
    })
    let number31 = accionsEix31Compliment && accionsEix31Compliment.length
    let total31 = accionsEix31Compliment && accionsEix31Compliment.reduce((a, b) => a + b, 0)
    let average31 = number31 && total31 && (total31/number31).toFixed(2)

    // Mitjana de compliment accions Eix 3 - Objectiu 2
    const accionsEix32Compliment = accionsEix3objetiu2 && accionsEix3objetiu2.map(element => {
        // return element && parseInt(element.valoracions[0].compliment)
        return element && parseInt(element.valoracions[(element.valoracions).length-1].compliment)
    })
    let number32 = accionsEix32Compliment && accionsEix32Compliment.length
    let total32 = accionsEix32Compliment && accionsEix32Compliment.reduce((a, b) => a + b, 0)
    let average32 = number32 && total32 && (total32/number32).toFixed(2)

    // Mitjana de compliment accions Eix 3 - Objectiu 3
    const accionsEix33Compliment = accionsEix3objetiu3 && accionsEix3objetiu3.map(element => {
        // return element && parseInt(element.valoracions[0].compliment)
        return element && parseInt(element.valoracions[(element.valoracions).length-1].compliment)
    })
    let number33 = accionsEix33Compliment && accionsEix33Compliment.length
    let total33 = accionsEix33Compliment && accionsEix33Compliment.reduce((a, b) => a + b, 0)
    let average33 = number33 && total33 && (total33/number33).toFixed(2)

    // Array mitjanes
    let averageArray3 = [average31, average32, average33]

    // Mitjana de compliment accions Eix 4 - Objectiu 1
    const accionsEix41Compliment = accionsEix4objetiu1 && accionsEix4objetiu1.map(element => {
        // return element && parseInt(element.valoracions[0].compliment)
        return element && parseInt(element.valoracions[(element.valoracions).length-1].compliment)
    })
    let number41 = accionsEix41Compliment && accionsEix41Compliment.length
    let total41 = accionsEix41Compliment && accionsEix41Compliment.reduce((a, b) => a + b, 0)
    let average41 = number41 && total41 && (total41/number41).toFixed(2)

    // Mitjana de compliment accions Eix 4 - Objectiu 2
    const accionsEix42Compliment = accionsEix4objetiu2 && accionsEix4objetiu2.map(element => {
        // return element && parseInt(element.valoracions[0].compliment)
        return element && parseInt(element.valoracions[(element.valoracions).length-1].compliment)
    })
    let number42 = accionsEix42Compliment && accionsEix42Compliment.length
    let total42 = accionsEix42Compliment && accionsEix42Compliment.reduce((a, b) => a + b, 0)
    let average42 = number42 && total42 && (total42/number42).toFixed(2)

    // Mitjana de compliment accions Eix 4 - Objectiu 3
    const accionsEix43Compliment = accionsEix4objetiu3 && accionsEix4objetiu3.map(element => {
        // return element && parseInt(element.valoracions[0].compliment)
        return element && parseInt(element.valoracions[(element.valoracions).length-1].compliment)
    })
    let number43 = accionsEix43Compliment && accionsEix43Compliment.length
    let total43 = accionsEix43Compliment && accionsEix43Compliment.reduce((a, b) => a + b, 0)
    let average43 = number43 && total43 && (total43/number43).toFixed(2)

    // Array mitjanes
    let averageArray4 = [average41, average42, average43]

    // Array mitjana Eixs
    let average1 = parseFloat(average11) + parseFloat(average12) + parseFloat(average13) + parseFloat(average14)
    let average2 = parseFloat(average21) + parseFloat(average22) + parseFloat(average23) + parseFloat(average24)
    let average3 = parseFloat(average31) + parseFloat(average32) + parseFloat(average33)
    let average4 = parseFloat(average41) + parseFloat(average42) + parseFloat(average43)

    let averageArrays1 = [ parseFloat(average11), parseFloat(average12), parseFloat(average13), parseFloat(average14) ]
    let averageArrays2 = [ parseFloat(average21), parseFloat(average22), parseFloat(average23), parseFloat(average24) ]
    let averageArrays3 = [ parseFloat(average31), parseFloat(average32), parseFloat(average33) ]
    let averageArrays4 = [ parseFloat(average41), parseFloat(average42), parseFloat(average43) ]

    let averageTotal = [ averageArrays1, averageArrays2, averageArrays3, averageArrays4 ]

    let averageEixos = [
        (average1/4).toFixed(2),
        (average2/4).toFixed(2),
        (average3/3).toFixed(2),
        (average4/3).toFixed(2),
    ]

    const eixosDescripcions = [
        "Millorar la qualitat de vida de les persones usuàries i les seves famílies.",
        "Millorar el desenvolupament de tots els professionals perquè creixi l'entitat.",
        "Promoure canvis socials pers sensibilitzar la societat.",
        "Treballar per assegurar que el creixement de l'entitat sigui sostenible en el temps."
    ]

    const eixosExemples = [
        "Per exemple que les persones ateses puguin decidir segons els seus interessos, que es defensin els seus drets, que es potenciÏ la inserció laboral o tenir nous suports i més moderns per poder tenir més qualitat de vida.",
        "Per exemple assegurar el benestar de tots els treballadors i treballadores de l'entitat, impulsar la transformació digital o integrar els ODS en el funcionament de l'entitat.",
        "Per exemple fer aliances amb altres entitats del sector i amb les administracions públiques perquè entenguin les necessitats de l'entitat i aconseguir més notorietat.",
        "Per exemple treballar perquè tots els serveis de l'entitat tinguin els recursos necessaris, promoure les inversions que calgui i vendre més productes propis com la xocolata o les patates xips."
    ]

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.menu}>
                    {
                        resultArrayResponsables && resultArrayResponsables.map((element, index) => {
                            return (
                                <>
                                    <p>{element}</p>
                                </>
                            ) 
                        })
                    }
                </div>
            </div>
            <div>
                {
                    titolsArray && titolsArray.map((element, ordre) => {
                        return (
                            <>
                            <div className={styles.eixname}>
                                <img src={ordre === 0 ? Eixos1 : ordre === 1 ? Eixos2 : ordre === 2 ? Eixos3 : Eixos4} alt='Eix'/>
                                <Eix name={nameEixos && nameEixos[ordre]} descripcio={eixosDescripcions[ordre]} exemple={eixosExemples[ordre]} percentatge={averageEixos && averageEixos[ordre]} type={"h1"}></Eix>
                            </div>
                                {
                                    element && element.map((elementTitle, index) => {
                                        return (
                                            <>
                                                <div className={styles.titles}>
                                                    <i className={visible === true ? "fa-solid fa-circle-arrow-up" : "fa-solid fa-circle-arrow-down"} onClick={handleOnChange}></i>
                                                    <h3><Eix name={elementTitle} percentatge={averageTotal[ordre][index]} type={"h3"}></Eix></h3>
                                                </div>
                                                <table className={visible === true ? styles.tablesVisible : styles.tablesNoVisible}>
                                                    <tr>
                                                    <th>Titol</th>
                                                    <th>Responsable</th>
                                                    <th>Esforç</th>
                                                    <th>Impacte</th>
                                                    <th>Compliment</th>
                                                    </tr>
                                                    { 
                                                        accionsArray[ordre] && accionsArray[ordre].map(element => {
                                                            return (
                                                                element.map(element => {
                                                                    return ( 
                                                                        <tr>
                                                                            <td>{element.titol}</td>
                                                                            <td>{element.responsable}</td>
                                                                            <td>{element.valoracions[0].esforç}</td>
                                                                            <td>{element.valoracions[0].impacte}</td>
                                                                            <td><Eix percentatge={parseFloat(element.valoracions[0].compliment)} type={"h3"}></Eix></td>
                                                                        </tr>
                                                                    )
                                                                })
                                                            )
                                                        })
                                                    }  
                                                </table>
                                            </>
                                        )
                                    })
                                }
                            </>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default Responsable